import { SegmentedControl } from '@eo/shared';
import { Moon, Sun } from 'lucide-react';

import { useThemeMode } from '../../theme';
import type { ThemeMode } from '../../theme';

const OPTIONS = [
  { value: 'auto' as const, label: 'Auto' },
  { value: 'light' as const, label: 'Light', icon: <Sun className="size-4" /> },
  { value: 'dark' as const, label: 'Dark', icon: <Moon className="size-4" /> },
];

export function AppearanceControl() {
  const [mode, setMode] = useThemeMode();

  return (
    <div className="flex w-full flex-col gap-4 sm:w-auto sm:flex-row sm:items-center sm:gap-6">
      <span className="text-sm text-text-secondary">Appearance</span>
      <SegmentedControl<ThemeMode>
        ariaLabel="Appearance"
        options={OPTIONS}
        value={mode}
        onChange={setMode}
        className="flex h-12 w-full sm:inline-flex sm:h-auto sm:w-auto"
        optionClassName="h-full flex-1 sm:h-8 sm:flex-initial"
      />
    </div>
  );
}
